import { Link, NavLink } from 'react-router'
import { FlaskConical, Settings } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Logo } from '@/components/brand/Logo'
import { USING_DEMO_RATES } from '@/features/convert/useRates'
import { LanguageToggle, SearchTrigger, ThemeToggle } from './Controls'

export function TopBar() {
  const { t } = useTranslation()
  return (
    <header className="sticky top-0 z-20 hidden h-[72px] items-center gap-4 border-b border-line bg-bg/75 px-6 backdrop-blur-xl md:flex lg:px-8">
      <SearchTrigger variant="field" />
      <div className="ms-auto flex items-center gap-1">
        <LanguageToggle />
        <ThemeToggle />
        <NavLink
          to="/settings"
          aria-label={t('nav.settings')}
          title={t('nav.settings')}
          className="inline-flex size-10 items-center justify-center rounded-xl text-muted transition hover:bg-surface-2 hover:text-fg lg:hidden"
        >
          <Settings className="size-[1.15rem]" />
        </NavLink>
      </div>
    </header>
  )
}

export function MobileHeader() {
  return (
    <header className="sticky top-0 z-20 flex h-16 items-center gap-2 border-b border-line bg-bg/80 ps-4 pe-2 backdrop-blur-xl md:hidden">
      <Link to="/" aria-label="GlobalX">
        <Logo />
      </Link>
      <div className="ms-auto flex items-center">
        <SearchTrigger variant="icon" />
        <LanguageToggle />
        <ThemeToggle />
      </div>
    </header>
  )
}

/** Always-visible notice about which data is real and which is still demo (D14). */
export function DemoNotice() {
  const { t } = useTranslation()
  return (
    <div
      role="note"
      className="flex items-center justify-center gap-2 bg-demo-soft px-4 py-1.5 text-center text-xs font-medium text-demo"
    >
      <FlaskConical className="size-3.5 shrink-0" aria-hidden />
      {USING_DEMO_RATES ? t('common.demoData') : t('common.liveRatesNotice')}
    </div>
  )
}
